import { useMemo } from "react";
import { useLocation } from "wouter";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertCircle, Home } from "lucide-react";
import { saveReturnUrl } from "@/utils/stytchAuthHelpers";

const PROTECTED_ROUTE_PREFIXES = [
  '/my-applications',
  '/applications-board',
  '/candidate-dashboard',
  '/company-dashboard',
  '/job-posting',
  '/jobs-overview',
  '/job-view/',
  '/company-profile',
  '/company-setup',
  '/calendar-settings',
  '/settings',
  '/matching/',
  '/job/',
  '/candidate-profile',
  '/job-search',
  '/job-recommendations',
  '/interview-scheduling/',
  '/mock-interview/',
  '/incoming-applications',
  '/dashboard',
];

export default function NotFound() {
  const [location, setLocation] = useLocation();

  // Save return URL immediately on render (not in useEffect which can be delayed)
  // useMemo ensures this only runs once per mount
  useMemo(() => {
    if (typeof window !== 'undefined') {
      const fullPath = window.location.pathname + window.location.search;
      const isProtectedRoute = PROTECTED_ROUTE_PREFIXES.some(prefix => 
        fullPath.startsWith(prefix)
      );
      
      if (isProtectedRoute) {
        saveReturnUrl(fullPath);
        console.log('[NotFound] Saved protected route for post-login redirect:', fullPath);
      }
    }
  }, []);

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gray-50">
      <Card className="w-full max-w-md mx-4">
        <CardContent className="pt-6">
          <div className="flex items-center gap-3 mb-4">
            <AlertCircle className="h-8 w-8 text-red-500" />
            <h1 className="text-2xl font-bold text-gray-900">Page Not Found</h1>
          </div>

          <p className="text-gray-600 mb-4">
            The page "{location}" doesn't exist or you don't have permission to access it.
          </p>

          <Button 
            onClick={() => setLocation("/")} 
            className="w-full bg-base-primary hover:bg-base-primary-hover text-white"
          >
            <Home className="w-4 h-4 mr-2" />
            Go Home
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
